import { createEntityAdapter } from '@reduxjs/toolkit';
import { apiSlice } from '../app/api/apiSlice';

// Entity adapter for applications
const applicationAdapter = createEntityAdapter({
  selectId: (item) => item._id, // Use `_id` as the unique identifier
});

const initialState = applicationAdapter.getInitialState();

// API slice
export const applicationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all applications
    getApplications: builder.query({
      query: () => '/applications',
      transformResponse: (responseData) =>
        applicationAdapter.setAll(initialState, responseData),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.ids.map((id) => ({ type: 'Applications', id })),
              { type: 'Applications', id: 'LIST' },
            ]
          : [{ type: 'Applications', id: 'LIST' }],
    }),

    // Fetch application by ID
    getApplicationById: builder.query({
      query: (id) => `/applications/${id}`,
      transformResponse: (responseData) =>
        applicationAdapter.setOne(initialState, responseData),
      providesTags: (result, error, id) => [{ type: 'Applications', id }],
    }),

    // Create a new application
    createApplication: builder.mutation({
      query: (newApplication) => ({
        url: '/applications',
        method: 'POST',
        body: newApplication,
      }),
      invalidatesTags: [{ type: 'Applications', id: 'LIST' }],
    }),

    // Update an existing application by ID
    updateApplication: builder.mutation({
      query: ({ id, ...updatedApplication }) => ({
        url: `/applications/${id}`,
        method: 'PUT',
        body: updatedApplication,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Applications', id }],
    }),

    // Delete an application by ID
    deleteApplication: builder.mutation({
      query: (id) => ({
        url: `/applications/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Applications', id }],
    }),
  }),
});

export const {
  useGetApplicationsQuery,
  useGetApplicationByIdQuery,
  useCreateApplicationMutation,
  useUpdateApplicationMutation,
  useDeleteApplicationMutation,
} = applicationApiSlice;
